import { React, useEffect } from 'react';
import { Trans } from 'react-i18next';
import { Image } from 'react-bootstrap';

import bgBanner from '../../assets/images/career/bg_career.png';
import bannerCorner from '../../assets/icons/jobs/bannerCorner.svg';

const CareerBanner = props => {

    useEffect(() => {
        props.changeLanguageColor("white")
    }, [])

    return (
        <section className='careerBanner' style={{ backgroundImage: "url(" + bgBanner + ")" }}>
            <div className='corner d-none d-lg-block'>
                <Image fluid src={bannerCorner} />
            </div>
            <div className='content'>
                <div className='container'>
                    <div className='d-flex flex-row align-item-center justify-content-center justify-content-md-start'>
                        <div className='col-12 col-md-10 offset-md-1 d-flex'>
                            <div className='floating-block'>
                                <div className='line-animate'>
                                    <span className="line line-top"></span>
                                    <span className="line line-right"></span>
                                    <span className="line line-bottom"></span>
                                    <span className="line line-left"></span>
                                </div>
                                <h1 className='text-uppercase'><Trans t={props.t} i18nKey={props.t('jobs:banner.title')} /></h1>
                                <h2><Trans t={props.t} i18nKey={props.t('jobs:banner.sub-title')} /></h2>
                                <p className='m-0'><Trans t={props.t} i18nKey={props.t('jobs:banner.text')} /></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CareerBanner;